import { useContext } from "react";
import { ParagraphText } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { Box } from "@mui/material";
import { SORT } from "../../../../constants";
import { SortArrow } from "../../../Features/NewInvoiceBook/InvoiceBookPages/InvoiceList";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const TableHeader = ({ filters, handleAscending, disabled = false }) => {
  const [I18n] = useContext(LanguageContext);

  return (
    <Box className="invoiceListTableHeader accountTableHeaderMain">
      <Box className="invListTableHeaderCol fiveColumn textLeft">
        <span className="fontSize12 fontWeight500 newLightColor">{I18n.contact}</span>
      </Box>
      <Box className="invListTableHeaderCol fiveColumn textLeft">
        <span className="fontSize12 fontWeight500 newLightColor">{I18n.status}</span>
      </Box>
      <Box
        id="pending_payment_date_sort_header"
        onClick={
          disabled
            ? undefined
            : () => {
              triggerLogEvent(analytics, "w_pending_sort");
              handleAscending();
            }
        }
        className={`invListTableHeaderCol fiveColumn textLeft ${disabled ? "" : "cursorPointer"}`}
      >
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          {I18n.last_trx_date || "Last trx date"}{" "}
          <SortArrow
            isAscending={filters?.sort === SORT.Newest}
            disabled={disabled}
          />
        </ParagraphText>
      </Box>
      <Box className="invListTableHeaderCol fiveColumn textRight">
        <span className="fontSize12 fontWeight500 newLightColor">{I18n.amount}</span>
      </Box>
      <Box className="invListTableHeaderCol fiveColumn justifyCenter">
        <span className="fontSize12 fontWeight500 newLightColor">{I18n.actions}</span>
      </Box>
    </Box>
  );
};

export default TableHeader;
